import { LicenseInfo } from '@goshippo/components';

import { environment } from '~/src/utils/environment';

export const setupMui = () => LicenseInfo.setLicenseKey(environment.MUI_LICENSE_KEY);
